export default __webpack_public_path__ + "static/media/pdf_guibackground.0e1d3042.png";